// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"79b9ea75","440":"89c7e733","477":"3c2c5851","681":"43a71a0e"}[chunkId] + ".chunk.js";
};